<template>
  <div class="youtube-star-summary-card apple-shadcn-card">
    <div class="thumbnail-bg" :style="{ backgroundImage: `url(${thumbnailUrl})` }"></div>
    
    <div class="content-overlay">
      <div class="header-text">
        <p class="title">Your Latest YouTube Hit!</p>
      </div>

      <div class="stats-panel">
        <div class="stats-row">
          <span class="stat-item">
            <svg class="stat-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>{{ formatNumber(submission.views) }}</span>
          </span>
          <span class="stat-item">
            <svg class="stat-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>{{ formatNumber(submission.likes) }}</span>
          </span>
          <span class="stat-item coins">
             <img src="@/assets/img/coin.svg" class="stat-icon coin-icon" />
            <span>{{ formatNumber(submission.coinsEarned) }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YouTubeStarSummaryCard',
  props: {
    submission: {
      type: Object,
      required: true,
    },
  },
  computed: {
    thumbnailUrl() {
      if (this.submission && this.submission.url) {
        const videoId = this.getVideoId(this.submission.url);
        // Using hqdefault for better quality if available, falls back if not.
        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`; 
      }
      return require('@/assets/img/youtube-placeholder.svg'); 
    },
  },
  methods: {
    getVideoId(url) {
      const patterns = [
        /(?:youtube\.com\/.*[?&]v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
        /^([a-zA-Z0-9_-]{11})$/
      ];
      for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match && match[1]) return match[1];
      }
      return null;
    },
    formatNumber(num) {
      if (num === undefined || num === null) return '0';
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num.toString();
    },
  }
};
</script>

<style scoped>
.apple-shadcn-card {
  font-family: 'Poppins', sans-serif;
  border-radius: 16px; /* Slightly larger radius */
  overflow: hidden;
  position: relative;
  height: 100%;
  background-color: #1c1c1e; /* Dark fallback */
  transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;
}

.apple-shadcn-card:hover {
  /* transform: translateY(-4px); */ /* Optional: subtle lift on hover */
  /* box-shadow: 0 10px 25px rgba(0,0,0,0.1), 0 5px 10px rgba(0,0,0,0.05); */
}

.thumbnail-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.apple-shadcn-card:hover .thumbnail-bg {
  transform: scale(1.03);
}

.content-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Pushes header to top, panel to bottom */
  padding: 16px;
  box-sizing: border-box;
  /* Optional subtle gradient over the whole image for text legibility at the top */
  background: linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, transparent 30%, transparent 70%, rgba(0,0,0,0.1) 100%);
}

.header-text {
  /* Nothing specific needed if text is white and gradient helps */
}

.header-text .title {
  font-size: 1rem; /* Adjusted size */
  font-weight: 600;
  color: white;
  line-height: 1.3;
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
  /* Keep text truncation for safety */
  overflow: hidden; 
  text-overflow: ellipsis; 
  white-space: nowrap;
}

.stats-panel {
  background-color: rgba(28, 28, 30, 0.75); /* Darker, more saturated glass */
  backdrop-filter: blur(18px) saturate(180%);
  -webkit-backdrop-filter: blur(18px) saturate(180%); /* Safari */
  border-radius: 12px;
  padding: 10px 12px; /* Adjusted padding slightly for a tighter fit if no status */
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.stats-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* margin-bottom: 8px; Removed or reduced as status badge is gone */
}

.stat-item {
  display: flex;
  align-items: center;
  color: #E5E5EA; /* Light grey for text */
  font-size: 0.8rem;
  font-weight: 500;
}

.stat-icon {
  width: 16px; /* Consistent icon size */
  height: 16px;
  margin-right: 6px;
  color: #8E8E93; /* Medium grey for icons */
}

.stat-item.coins .coin-icon {
  filter: none; /* Remove previous invert if coin SVG is already light/gold */
  /* If coin SVG is dark, use: filter: brightness(0) saturate(100%) invert(86%) sepia(39%) saturate(663%) hue-rotate(347deg) brightness(102%) contrast(101%); for gold */
  /* For this, assuming coin.svg is a gold color or we make it so */
   width: 15px; /* Slightly adjust if needed */
   height: 15px;
   filter: drop-shadow(0 0 3px rgba(255, 215, 0, 0.5));
}
.stat-item.coins span {
  color: #FFD700; /* Gold color for coin text */
}

/* Status badge styles removed */

</style> 